/* eslint-disable prefer-destructuring */
/* eslint-disable no-restricted-globals */
/* eslint-disable react/no-danger */
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import bindMethods from 'auto-bind';
import styled from 'styled-components';
import ReactTable from 'react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import 'react-table/react-table.css';

import { updateFieldZone } from '../../state/filters';
import { setError } from '../../state/settings';
import { FIELD_ZONE_KEY, getFilters } from '../../state/selectors/filters';
import { XOS_RED } from '../../constants/colors';
import {
  ERR_DUPLICATE_NAMES, ERR_BLANK_FIELDS, VALID_INTEGERS, ERR_GROUP_SELECT, ERR_NO_FILTERS,
} from '../../constants/errors';
import { FIELD_ZONE_MAP, FIELD_ZONE_CODE } from '../../constants/filters';


const ErrorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: .75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: .25rem;
  color: #c94141;
  background-color: #f8d7da;
`;

const DeleteTableCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${XOS_RED};
`;

class FieldZoneSettings extends PureComponent {
  constructor(props) {
    super(props);
    bindMethods(this);
  }

  getCellType(cell) {
    const { filters } = this.props;
    const isValid = Object.keys(filters[cell.index]).length > 0;
    if (!isValid) {
      return cell.column.Header === 'Name' ? 'New Filter' : '';
    }
    return filters[cell.index][FIELD_ZONE_MAP[cell.column.Header]];
  }


  toggleError(status, location, message) {
    const { setError } = this.props;
    setError({
      status,
      location,
      message,
    });
  }

  handleRowEdits(state, rowInfo) {
    const { filters, settings } = this.props;
    const { error } = settings;
    const newFilterData = state.data[filters.length - 1];
    if (rowInfo.index === filters.length - 1 && !newFilterData.filterFormulaId) {
      // if error is active AND either the name, the minimum and max distance is blank
      if (!error
        && (!newFilterData.name || !newFilterData.operand1Min || !newFilterData.operand1Max)) {
        this.toggleError(true, ERR_BLANK_FIELDS);
        return {};
      }
      // if required fields are filled out, add filterFormulaId marker to avoid stack trace error
      // + adding item to state
      if (!error) {
        const index = filters.length - 1;
        filters[index] = {
          ...filters[index],
          filterFormulaId: FIELD_ZONE_CODE,
        };
        this.handleUpdate(filters);
      }
      return {};
    }
    return {};
  }

  deleteFilter(cell) {
    const itemToDelete = cell.original;
    const { filters } = this.props;
    const filteredFieldZoneFilters = filters.filter(filter => filter.name !== itemToDelete.name);
    this.handleUpdate(filteredFieldZoneFilters);
  }


  handleUpdate(filters) {
    const { groupId, updateFieldZone } = this.props;
    updateFieldZone(FIELD_ZONE_CODE, groupId, filters);
    this.toggleError(false, null, '');
  }

  renderEditable(cell) {
    const { filters } = this.props;
    const data = filters;
    const field = FIELD_ZONE_MAP[cell.column.Header];

    return (
      <div
        style={{ backgroundColor: '#fafafa' }}
        contentEditable
        suppressContentEditableWarning
        onBlur={(e) => {
          const input = e.target.innerHTML;

          if (input === '') return this.toggleError(true, FIELD_ZONE_KEY, ERR_BLANK_FIELDS);

          // check for duplicate name
          if (cell.column.Header === 'Name' && data.find(f => f.name === input)) {
            const name = data
              .filter(f => f[FIELD_ZONE_MAP[cell.column.Header]] === cell.original.name)[0].name;
            e.target.innerHTML = name;
            return this.toggleError(true, FIELD_ZONE_KEY, ERR_DUPLICATE_NAMES);
          }

          // if Down and Min Distance are not numbers
          const invalidNumber = isNaN(+input);
          if ((cell.column.Header === 'Min Distance' || cell.column.Header === 'Max Distance') && invalidNumber) return this.toggleError(true, FIELD_ZONE_KEY, VALID_INTEGERS);

          const filters = data.map((filter) => {
            if (filter[field] === data[cell.index][field] && cell.original.name === filter.name) {
              return {
                ...filter,
                [field]: input,
              };
            }
            return filter;
          });
          this.handleUpdate(filters);
          return {};
        }}
        dangerouslySetInnerHTML={{
          __html: this.getCellType(cell),
        }}
      />
    );
  }

  render() {
    const { filters, groupId, settings } = this.props;
    const { status, location, message } = settings.error;

    if (!groupId) return <ErrorContainer>{ERR_GROUP_SELECT}</ErrorContainer>;

    if (!filters.length > 0) return <ErrorContainer>{ERR_NO_FILTERS}</ErrorContainer>;

    return (
      <React.Fragment>
        {status && location === FIELD_ZONE_KEY && <ErrorContainer>{`Error: ${message}`}</ErrorContainer>}
        <ReactTable
          resizable={false}
          showPagination={false}
          getTrProps={(state, rowInfo) => this.handleRowEdits(state, rowInfo)}
          getTdProps={() => ({
            style: {
              textAlign: 'center',
            },
          }
          )}
          data={filters}
          columns={[
            {
              Header: 'Name',
              Cell: this.renderEditable,
            },
            {
              Header: 'Min Distance',
              Cell: this.renderEditable,
            },
            {
              Header: 'Max Distance',
              Cell: this.renderEditable,
            },
            {
              Header: '',
              Cell: cell => (
                <DeleteTableCell>
                  <FontAwesomeIcon icon={faTimesCircle} onClick={() => this.deleteFilter(cell)} />
                </DeleteTableCell>
              ),
            },
          ]}
          pageSize={filters.length}
          className="-striped -highlight"
        />
      </React.Fragment>
    );
  }
}

FieldZoneSettings.propTypes = {
  filters: PropTypes.array.isRequired,
  groupId: PropTypes.number,
  setError: PropTypes.func.isRequired,
  settings: PropTypes.object.isRequired,
  updateFieldZone: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  filters: getFilters(FIELD_ZONE_KEY, state.filters),
  settings: state.settings,
  groupId: state.navigationSelection.group.groupId,
});

const mapDispatchToProps = {
  setError,
  updateFieldZone,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FieldZoneSettings);
